import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Globals} from '../../global/globals';
import {Observable} from 'rxjs';
import {CategoryCreationDto} from "../../dtos/verbal-action/category/category-creation-dto";

@Injectable({
  providedIn: 'root'
})
export class VerbalActionCategoryService {

  private baseUri: string = this.globals.backendUri + '/va/categories';

  constructor(private httpClient: HttpClient, private globals: Globals) {
  }

  getRootCategories(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUri + '/roots');
  }

  getCategory(id: number): Observable<any> {
    return this.httpClient.get<any>(this.baseUri + '/' + id);
  }

  searchCategories(params: HttpParams): Observable<any> {
    return this.httpClient.get<any>(this.baseUri, {params});
  }

  createCategory(category: CategoryCreationDto): Observable<any> {
    return this.httpClient.post<any>(this.baseUri, category);
  }

  updateCategory(id: number, category: CategoryCreationDto): Observable<any> {
    return this.httpClient.put<any>(this.baseUri + '/' + id, category);
  }

  deleteCategory(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.baseUri + '/' + id);
  }
}
